import { render, staticRenderFns } from "./WyhSettingUser.vue?vue&type=template&id=3a0a2c59&scoped=true&"
import script from "./WyhSettingUser.vue?vue&type=script&lang=js&"
export * from "./WyhSettingUser.vue?vue&type=script&lang=js&"
import style0 from "./WyhSettingUser.vue?vue&type=style&index=0&id=3a0a2c59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a2c59",
  null
  
)

export default component.exports